module.exports = __webpack_public_path__ + "img/share3.4132f2e7.png";